import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d98a70a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workspace-source" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "desc" }
const _hoisted_6 = {
  key: 0,
  class: "location"
}

import { computed } from 'vue'
import { FileIcon } from '@zhuowenli/vue-feather-icons'
import { useWorkspaceStore } from '@/rd/WorkspaceStore'
import { LoadMode } from '@webapp/util/AsyncData'
import { FileUtil } from '@webapp/util/FileUtil'
import { osDisplayName } from '@webapp/util/DeviceUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkspaceSourcePanel',
  props: {
    workspaceId: {}
  },
  setup(__props: any) {

const props = __props;



const workspaceStore = useWorkspaceStore()

const workspaceRef = computed(() => workspaceStore.getAsyncWorkspace(props.workspaceId, LoadMode.EnsureLoaded)?.data)
const typeInfoRef = computed(() => workspaceRef.value?.workspaceTypeInfo)
// The workspace's dataFilePath is the authoritative source-file location (client-maintained). It is
// never derived from the last sync -- an absent value means the source location is genuinely unknown.
const filePathRef = computed(() => workspaceRef.value?.dataFilePath)
const fileNameRef = computed(() => {
  const name = FileUtil.fileName(filePathRef.value)
  return name ? FileUtil.stripExtension(name) : undefined
})
const folderRef = computed(() => FileUtil.folder(filePathRef.value))
const descriptionRef = computed(() => {
  const fileTypeDesc = typeInfoRef.value?.description ?? 'Unknown file'
  const device = workspaceRef.value?.clientDevice
  const os = osDisplayName(device?.os)
  if (!device || !os) {
    return fileTypeDesc
  }
  return device.name ? `${fileTypeDesc} on ${os} (${device.name})` : `${fileTypeDesc} on ${os}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (typeInfoRef.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: typeInfoRef.value.icon,
            alt: typeInfoRef.value.product
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createBlock(_unref(FileIcon), {
            key: 1,
            size: "40"
          }))
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(fileNameRef.value ?? 'Unknown file'), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(descriptionRef.value), 1),
    (folderRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(folderRef.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})